import { useTranslation } from "src/i18n/context";
import { useUserStore } from "src/store/userStore";

function ProfileInfo() {
  const userInfo = useUserStore((state) => state.userInfo);
  const { t } = useTranslation();

  if (!userInfo) {
    return (
      <div className="profile__info">
        <br />
        <h2>{t("profile.educationInfo")}</h2>
        <p>{t("common.loading")}</p>
      </div>
    );
  }

  return (
    <div className="profile__info">
      <br />
      
      {/* Shaxsiy ma'lumotlar */}
      <div className="profile__info-section">
        <h3>{t("profile.personalData")}</h3>
        {userInfo.fullName && (
          <p>
            {t("profile.fullName")}: <span>{userInfo.fullName}</span>
          </p>
        )}
        {userInfo.gender && (
          <p>
            {t("profile.gender")}: <span>{userInfo.gender}</span>
          </p>
        )}
        {userInfo.phoneNumber && (
          <p>
            {t("profile.phoneNumber")}: <span>{userInfo.phoneNumber}</span>
          </p>
        )}
        {userInfo.citizenship && (
          <p>
            {t("profile.citizenship")}: <span>{userInfo.citizenship}</span>
          </p>
        )}
        {userInfo.nationality && (
          <p>
            {t("profile.nationality")}: <span>{userInfo.nationality}</span>
          </p>
        )}
        {userInfo.permanentAddress && (
          <p>
            {t("profile.permanentAddress")}: <span>{userInfo.permanentAddress}</span>
          </p>
        )}
      </div>

      {/* Ta'lim ma'lumotlari */}
      {(userInfo.cathedraName || userInfo.specialityName || userInfo.course) && (
        <div className="profile__info-section">
          <h3>{t("profile.educationInfo")}</h3>
          {userInfo.cathedraName && (
            <p>
              {t("profile.cathedra")}: <span>{userInfo.cathedraName}</span>
            </p>
          )}
          {userInfo.specialityName && (
            <p>
              {t("profile.speciality")}: <span>{userInfo.specialityName}</span>
            </p>
          )}
          {userInfo.course && (
            <p>
              {t("profile.course")}: <span>{userInfo.course}</span>
            </p>
          )}
        </div>
      )}

      {/* Universitetlar ma'lumotlari - bir nechta universitet bo'lishi mumkin */}
      {userInfo.universitiesInfo && userInfo.universitiesInfo.length > 0 ? (
        <div className="profile__info-section">
          <h3>{t("profile.universitiesInfo")}</h3>
          {userInfo.universitiesInfo.map((uni, index) => (
            <div key={index} className="profile__info-university">
              {index > 0 && <hr style={{ margin: "16px 0", border: "none", borderTop: "1px solid #e8e8e8" }} />}
              {uni.universityName && (
                <p>
                  <strong>{t("profile.university")}:</strong> <span>{uni.universityName}</span>
                </p>
              )}
              {uni.employeeFormName && (
                <p>
                  {t("profile.employeeForm")}: <span>{uni.employeeFormName}</span>
                </p>
              )}
              {uni.employeePositionName && (
                <p>
                  {t("profile.employeePosition")}: <span>{uni.employeePositionName}</span>
                </p>
              )}
              {uni.employeeRateName && (
                <p>
                  {t("profile.employeeRate")}: <span>{uni.employeeRateName}</span>
                </p>
              )}
              {uni.employeeStatusName && (
                <p>
                  {t("profile.employeeStatus")}: <span>{uni.employeeStatusName}</span>
                </p>
              )}
            </div>
          ))}
        </div>
      ) : userInfo.universityName ? (
        // Agar universitiesInfo bo'lmasa, lekin universityName bo'lsa
        <div className="profile__info-section">
          <h3>{t("profile.educationInfo")}</h3>
          <p>
            {t("profile.university")}: <span>{userInfo.universityName}</span>
          </p>
          {userInfo.employeeFormName && (
            <p>
              {t("profile.employeeForm")}: <span>{userInfo.employeeFormName}</span>
            </p>
          )}
          {userInfo.employeePositionName && (
            <p>
              {t("profile.employeePosition")}: <span>{userInfo.employeePositionName}</span>
            </p>
          )}
          {userInfo.employeeRateName && (
            <p>
              {t("profile.employeeRate")}: <span>{userInfo.employeeRateName}</span>
            </p>
          )}
          {userInfo.employeeStatusName && (
            <p>
              {t("profile.employeeStatus")}: <span>{userInfo.employeeStatusName}</span>
            </p>
          )}
        </div>
      ) : null}
    </div>
  );
}

export default ProfileInfo;
